import classNames from 'classnames';
import * as React from 'react';

import { NavigationTrackerLink } from '../../ReactComponents/NavigationTracker/NavigationTrackerLink';
import { RenderHTML } from '../../ReactComponents/RenderHTML';
import { CallToActionViewModel } from './CallToActionViewModel.csharp';

// eslint-disable-next-line
declare let zE: any;

export const CallToAction = ({ model }: { model: CallToActionViewModel }) => {
    const link = model.phoneNumber ? `tel:${model.phoneNumber}` : model.url;

    const openChat = () => {
        zE('webWidget', 'show');
        zE('webWidget', 'open');
    };

    const linkContent = (
        <>
            <div className="CallToAction__Image">
                <div className={classNames('SvgIcon', `SvgIcon--${model.icon}`)} />
            </div>
            <h3 className="CallToAction__Heading">
                <span>{model.heading}</span>
            </h3>
        </>
    );

    return (
        <div className="CallToAction">
            {model.openChat ? (
                <div className="CallToAction__Link CallToAction__Link--OpenChat" onClick={openChat}>
                    {linkContent}
                </div>
            ) : (
                <NavigationTrackerLink
                    href={link}
                    className="CallToAction__Link"
                    target={model.openInNewTab ? '_blank' : '_self'}
                    rel="noreferrer"
                    source="CallToAction"
                    disableTracking={!model.trackNavigation}
                >
                    {linkContent}
                </NavigationTrackerLink>
            )}

            {model.description && <RenderHTML className="CallToAction__Caption" html={model.description} />}
        </div>
    );
};
